module.exports = __webpack_public_path__ + "media/placeholders/placeholder_06b-6b28a798.svg";